import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/heat-transfer-calculator',
  component: () => import('../../routes/HeatTransferCalculator.svelte'),
  card: {
    id: 'heat-transfer-calculator',
    title: 'Heat Transfer',
    description: "Calculate heat energy transfer using Q = mcΔT. Solve for any variable: heat, mass, specific heat, or temperature change.",
    icon: 'thermostat',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/heat-transfer-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Heat Transfer Calculator – Solve Q = mcΔT for Any Variable',
    description:
      'Free heat transfer calculator. Find heat energy, mass, specific heat capacity, or temperature change using Q = mcΔT. Includes common substance presets.',
  },
};

export default meta;